import { Components, Theme } from '@mui/material';

const MuiRadio: Components<Theme>['MuiRadio'] = {
  variants: [
    {
      props: {
        size: 'small',
      },
      style: ({ theme }) => ({
        padding: theme.spacing(1.5)
      }),
    },
  ]
};

export default MuiRadio;
